import { useMemo } from 'react';
import { stylesCombinatorFactory, } from '../helpers/stylesCombinatorFactory';
import { useThemeContext } from '../components/Theme';
import { stylePropsFactory, } from '../helpers/stylePropsFactory';
export const useStyles = (props) => {
    const { name, styles, visualState } = props;
    const themeContext = useThemeContext();
    const combineStyles = useMemo(() => stylesCombinatorFactory(styles), [styles]);
    const getStyles = useMemo(() => stylePropsFactory(combineStyles, visualState), [combineStyles, visualState]);
    return {
        settings: themeContext.settings,
        globalStyles: themeContext.componentsStyles?.[name],
        combineStyles,
        getStyles,
    };
};
